import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCalendar } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';
import { ConversionDateTimeService } from 'src/app/core/services/conversion/conversion-datetime.service';


@Component({
  selector: 'app-date-time-picker-dialog',
  standalone: true,
  templateUrl: './date-time-picker-dialog.component.html',
  imports: [CommonModule, FormsModule, MatCalendar, MatIconModule, MatButtonModule]
})
export class DateTimePickerDialogComponent {
  selectedDate: Date;
  hour: number;
  minute: number;
  period: string | null = null; // Only used for 12-hour format
  is12HourFormat: boolean;

  constructor(
    private dialogRef: MatDialogRef<DateTimePickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedDate: string, minDate: Date },
    private conversionDateTimeService: ConversionDateTimeService
  ) {
    // Determine the format preference
    this.is12HourFormat = this.conversionDateTimeService['is12HourFormat']

    const momentDate = moment(data.selectedDate);
    if (!momentDate.isValid()) {
      this.selectedDate = new Date();
    } else {
      this.selectedDate = momentDate.toDate();
    }

    this.minute = momentDate.minute();

    if (this.is12HourFormat) {
      this.hour = momentDate.hour() % 12 || 12;
      this.period = momentDate.hour() >= 12 ? 'PM' : 'AM';
    } else {
      this.hour = momentDate.hour();
      this.period = null;
    }
  }

  toggleAmPm() {
    if (this.period) {
      this.period = this.period === 'AM' ? 'PM' : 'AM';
    }
  }

  confirmDateTime() {
    const momentDate = moment(this.selectedDate);
    let hours = this.hour;

    if (this.is12HourFormat) {
      if (this.period === 'PM' && hours !== 12) hours += 12;
      if (this.period === 'AM' && hours === 12) hours = 0;
    }

    momentDate.set({ hour: hours, minute: this.minute });
    this.dialogRef.close(momentDate.toDate());
  }

  increaseHour() {
    if (this.is12HourFormat) {
      this.hour = this.hour === 12 ? 1 : this.hour + 1;
    } else {
      this.hour = (this.hour + 1) % 24;
    }
  }

  decreaseHour() {
    if (this.is12HourFormat) {
      this.hour = this.hour === 1 ? 12 : this.hour - 1;
    } else {
      this.hour = this.hour === 0 ? 23 : this.hour - 1;
    }
  }

  increaseMinute() {
    this.minute = (this.minute + 1) % 60;
  }

  decreaseMinute() {
    this.minute = this.minute === 0 ? 59 : this.minute - 1;
  }

  closeDialog() {
    this.dialogRef.close(null);
  }
}
